// @flow
import React, { useCallback, type Node } from 'react';

import { Row } from 'app/common/components/Table';

import styles from './RowClickable.module.scss';;


type Props = {
  children: Node,
  loading: boolean,
  id: string,
  onClick: (id: string) => void,
}

const RowClickable = ({ children, loading, id, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(id);
  }, [onClick, id]);

  return (
    <Row
      className={styles.root}
      loading={loading}
      onClick={handleClick}
    >
      {children}
    </Row>
  );
};

export default RowClickable;
